"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyProject = exports.listTemplates = exports.searchCompany = void 0;
const rxjs_1 = require("rxjs");
const t = require("io-ts");
const operators_1 = require("rxjs/operators");
const sok_types_1 = require("@caddigital/sok-types");
const ActionTypes = require("../../actionTypes/project/copy");
const ListActions = require("../../actions/projects");
const Actions = require("../../actions/project/copy");
const validation_1 = require("../../utils/validation");
const errorHandling_1 = require("../../utils/errorHandling");
function searchCompany(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.SEARCH_COMPANY_REQUEST), (0, operators_1.mergeMap)((request) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'GET',
            url: `${baseUrl}api/customer/search/${request.payload}`
        }).pipe((0, operators_1.mergeMap)((x) => {
            const validate = t.array(sok_types_1.Customer.iCustomer).decode(x.response);
            const act = validate.fold((e) => Actions.searchCompanyFailed((0, errorHandling_1.parseValidationError)(e)), (c) => {
                return Actions.searchCompanySuccess(c);
            });
            return (0, rxjs_1.of)(act);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.searchCompanyFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    }));
}
exports.searchCompany = searchCompany;
function listTemplates(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_TEMPLATES_REQUEST), (0, operators_1.mergeMap)((request) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'GET',
            url: `${baseUrl}api/project/?type=TEMPLATE`
        }).pipe((0, operators_1.mergeMap)((x) => {
            const validate = t.array(sok_types_1.Project.iProject).decode(x.response);
            const act = validate.fold((e) => Actions.fetchTemplatesFailed((0, errorHandling_1.parseValidationError)(e)), (c) => {
                return Actions.fetchTemplatesSuccess(c);
            });
            return (0, rxjs_1.of)(act);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchTemplatesFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    }));
}
exports.listTemplates = listTemplates;
const validateCopy = (x) => {
    let v = (0, validation_1.isNotEmpty)('projectName')(x);
    if (x.type === 'COPY') {
        v = (0, validation_1.ap)((0, validation_1.isNotUndefined)('selectedCompany')(x.selectedCompanyId))(v);
    }
    else if (x.type === 'TEMPLATE') {
        v = (0, validation_1.ap)((0, validation_1.isNotUndefined)('copyFrom')(x.copyFrom))(v);
    }
    return v.fold((e) => (0, rxjs_1.throwError)(Actions.validateStepFailure(e)), () => (0, rxjs_1.of)(Actions.validateStepSuccess()));
};
function copyProject(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.COPY_PROJECT_REQUEST), (0, operators_1.mergeMap)((action) => validateCopy(action.payload).pipe((0, operators_1.mergeMap)(() => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: action.payload,
        url: `${baseUrl}api/project/copy`
    }).pipe((0, operators_1.mergeMap)((x) => {
        const validation = sok_types_1.Project.iProject.decode(x.response);
        const res = validation.fold((e) => [
            Actions.copyProjectFailure((0, errorHandling_1.parseAjaxErrorResponse)(x.response))
        ], (r) => [
            Actions.copyProjectSuccess(r),
            ListActions.fetchProjects()
        ]);
        return (0, rxjs_1.of)(...res);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.copyProjectFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(e)))));
}
exports.copyProject = copyProject;
//# sourceMappingURL=copy.js.map